import { getModelDataCommodities } from "@/_core/data/api_calls/relatives_values/model/getModelDataCommodities";
import { getModelDataCurrencies } from "@/_core/data/api_calls/relatives_values/model/getModelDataCurrencies";

/**
 * Retrieves model data for relative values based on the asset type.
 *
 * @param {object} ctx - Context variables for the API call.
 * @param {string} asset - Type of asset ('currency' or 'commodity').
 * @param {object} [assetExtraParams={}] - Additional parameters for commodity queries.
 * @returns {Promise<any>} - A promise resolving to the model data.
 */
export function getModelData(ctx, asset, assetExtraParams = {}) {
  switch (asset) {
    case "currency":
      return getModelDataCurrencies(ctx);
    case "commodity":
      return getModelDataCommodities(ctx, assetExtraParams);
    default:
      throw new Error(`Invalid asset type: ${asset}`);
  }
}
